import React from 'react'
import { useS4LContext } from '@s4l/react-context'

import { BottomSheet, Button, Typography } from '@s4l/ds'
import styles from './styles.module.css'

interface ConfirmExitProps {
  open: boolean
  onClose: () => void
  onContinueEditing: () => void
  onExitWithoutSaving: () => void
}

const ConfirmExit = ({
  open,
  onClose,
  onContinueEditing,
  onExitWithoutSaving,
}: ConfirmExitProps) => {
  const { i18n } = useS4LContext()

  return (
    <BottomSheet open={open} onClose={onClose}>
      <BottomSheet.Content
        title={i18n.formatMessage({ id: 'change-dates.unsaved-modal-title' })}
        modalOnDesktop
        size="s"
      >
        <div className={styles.container}>
          <Typography variant="body" size="m">
            {i18n.formatMessage({ id: 'change-dates.unsaved-modal-body' })}
          </Typography>
          <div className={styles.actions}>
            <Button variant="outlined-rounded" fullWidth onClick={onContinueEditing}>
              {i18n.formatMessage({ id: 'change-dates.unsaved-modal-button' })}
            </Button>
            <Button variant="filled-rounded" fullWidth onClick={onExitWithoutSaving}>
              {i18n.formatMessage({ id: 'change-dates.unsaved-modal-cta' })}
            </Button>
          </div>
        </div>
      </BottomSheet.Content>
    </BottomSheet>
  )
}

ConfirmExit.displayName = 'ConfirmExit'

export default ConfirmExit
